import { render, staticRenderFns } from "./Tasklist.vue?vue&type=template&id=47a80fc6"
import script from "./Tasklist.vue?vue&type=script&lang=js"
export * from "./Tasklist.vue?vue&type=script&lang=js"
import style0 from "./Tasklist.vue?vue&type=style&index=0&id=47a80fc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports